import { escapeCsvValue } from '@shared/csv'

export { escapeCsvValue }

/** Client-side CSV download (design.md §5.5/§5.7 — exports exactly the visible columns). */
export function downloadCsv(filename: string, header: string[], rows: (string | number)[][]): void {
  const escape = escapeCsvValue
  const csv = [header, ...rows].map((r) => r.map(escape).join(',')).join('\r\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/** Parse CSV text into rows of cells (RFC 4180 quoting; CRLF or LF line ends). */
export function parseCsv(text: string): string[][] {
  const rows: string[][] = []
  let row: string[] = []
  let cell = ''
  let quoted = false
  for (let i = 0; i < text.length; i++) {
    const ch = text[i]
    if (quoted) {
      if (ch === '"' && text[i + 1] === '"') {
        cell += '"'
        i++
      } else if (ch === '"') {
        quoted = false
      } else {
        cell += ch
      }
    } else if (ch === '"') {
      quoted = true
    } else if (ch === ',') {
      row.push(cell)
      cell = ''
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && text[i + 1] === '\n') i++
      row.push(cell)
      rows.push(row)
      row = []
      cell = ''
    } else {
      cell += ch
    }
  }
  if (cell || row.length) {
    row.push(cell)
    rows.push(row)
  }
  return rows.filter((r) => r.some((c) => c.trim()))
}

/**
 * SMB enrolment rows from an uploaded CSV: a header naming the URL and email columns
 * (`site_url`/`url`/`website`, `owner_email`/`email`), or two bare columns in that order.
 * `line` is the 1-based line in the file so errors point at the right row.
 */
export function enrolmentRows(text: string): { line: number; siteUrl: string; ownerEmail: string }[] {
  const rows = parseCsv(text.replace(/^﻿/, ''))
  if (!rows.length) return []
  const header = rows[0].map((h) => h.trim().toLowerCase().replace(/[\s-]+/g, '_'))
  const urlCol = header.findIndex((h) => ['site_url', 'url', 'website', 'site'].includes(h))
  const emailCol = header.findIndex((h) => ['owner_email', 'email', 'owner'].includes(h))
  const hasHeader = urlCol >= 0 && emailCol >= 0
  const [u, e] = hasHeader ? [urlCol, emailCol] : [0, 1]
  return rows.slice(hasHeader ? 1 : 0).map((r, i) => ({
    line: i + (hasHeader ? 2 : 1),
    siteUrl: (r[u] ?? '').trim(),
    ownerEmail: (r[e] ?? '').trim(),
  }))
}
